import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { getAdminUsers, createAdminUser } from '../api';

function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ username: '', password: '', role: 'user' });
  const [msg, setMsg] = useState(null);
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return navigate('/');
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await getAdminUsers();
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg(null);
    try {
      const res = await createAdminUser(form);
      setMsg({ type: 'success', text: `Created ${res.data.username}` });
      setForm({ username: '', password: '', role: 'user' });
      fetchUsers();
    } catch (err) {
      setMsg({ type: 'error', text: err?.response?.data?.message || 'Failed' });
    }
  };

  return (
    <div className="container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
        <h2>Admin — Users</h2>
        <button onClick={() => navigate('/admin')} className="btn">Back to Dashboard</button>
      </div>

      <div style={{ display: 'flex', gap: 20, marginTop: 18 }}>
        <div style={{ flex: 1 }}>
          <h3>All Users</h3>
          {loading ? (
            <div>Loading users...</div>
          ) : (
            <table className="table">
              <thead>
                <tr><th>ID</th><th>Username</th><th>Role</th><th>Created</th></tr>
              </thead>
              <tbody>
                {users.map(u => (
                  <tr key={u.id}>
                    <td>{u.id}</td>
                    <td>{u.username}</td>
                    <td>{u.role}</td>
                    <td>{new Date(u.createdAt).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div style={{ width: 360 }}>
          <h3>Create User</h3>
          <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <input name="username" placeholder="username" value={form.username} onChange={onChange} required />
            <input name="password" type="password" placeholder="password" value={form.password} onChange={onChange} required />
            <select name="role" value={form.role} onChange={onChange}>
              <option value="user">User</option>
              <option value="admin">Admin</option>
            </select>
            <button className="btn btn-primary" type="submit">Create</button>
          </form>
          {msg && <div style={{ marginTop: 8, color: msg.type === 'success' ? 'green' : 'red' }}>{msg.text}</div>}
        </div>
      </div>
    </div>
  );
}

export default AdminUsers;
